import { AddContact } from "api/models/request/customer/customer-contact";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { string } from "yup";

export const contactFormSchema = (): ObjectSchemaType<AddContact> => {
  return {
    fullName: {
      label: "Tên",
      type: InputType.text,
      gridSize: 12,
      validattionYupSchema: string().required().max(255),
    },
    departmentTypeId: {
      label: "Bộ phận",
      type: InputType.select,
      gridSize: 12,
      validattionYupSchema: string().required(),
    },
    email: {
      label: "Email",
      type: InputType.text,
      gridSize: 12,
      validattionYupSchema: string().email().max(255),
    },
    phoneNumber: {
      label: "Số điện thoại",
      type: InputType.text,
      gridSize: 12,
      validattionYupSchema: string().max(15),
    },
    customerId: { type: InputType.none },
  };
};
